import React from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
export const MetodoRaices = () => {
  const includes = ['Ingeniería de Precios: Calculadora de rentabilidad real con todos los costos (materiales, estructura, tiempo e impacto inflacionario argentino)', 'El Protocolo de Aumento en 4 Pasos: Cómo comunicar el aumento 12 días antes para que el 90% de tus clientas se queden', 'Scripts de Comunicación del Aumento: Mensajes exactos para estados, WhatsApp personal y respuestas a objeciones', 'El Aumento Escalonado: Cómo subir el precio en etapas cuando el salto es grande', 'La Fórmula de Posicionamiento del Precio como Inversión: El cambio de lenguaje que hace que tu precio nunca más parezca caro', 'El Protocolo OPA de Venta en Camilla: Cómo recomendar servicios adicionales de forma natural sin que la clienta sienta que le estás vendiendo', 'Los Adicionales con Mayor Margen por Rubro: Tabla completa para manicura, lashes, cejas y estética facial', 'Sistema de Packs: Cómo armar y comunicar packs de mantenimiento, combinados y de fidelidad que aumentan el ticket promedio', 'El Sistema de Upselling por Chat: Cómo vender más antes, durante y después del turno por WhatsApp', 'El Protocolo de los 3 Primeros Turnos: Cómo convertir una clienta nueva en clienta de alto ticket en 90 días', 'Autoridad Visual en Instagram: Fórmula de bio, sistema de fotos premium con celular, feed organizado, Highlights obligatorios y tipos de Reels que posicionan el precio', 'El Sistema de Referidos Premium: Cómo hacer que tus mejores clientas te traigan más clientas como ellas de forma sistemática', 'El Tracker de Expansión Pro: Los 6 indicadores mensuales para saber exactamente si tu negocio está creciendo', 'Plan de Implementación de 90 Días: El roadmap completo en 3 fases para aplicar todo sin abrumarte'];
  const comparisons = [{
    situacion: 'Querés subir el precio',
    sin: 'No sabés cuánto cobrar ni cómo comunicarlo sin perder clientas',
    con: 'Calculadora de rentabilidad real + protocolo de aumento en 4 pasos + scripts de comunicación exactos'
  }, {
    situacion: 'La inflación sube tus costos',
    sin: 'Tu margen se achica cada mes sin que te des cuenta',
    con: 'Sistema de revisión de precios cada 60 días con fórmula de ajuste aplicada a Argentina'
  }, {
    situacion: 'Querés ganar más sin más horas',
    sin: 'No encontrás la forma de crecer dentro de la agenda que ya tenés',
    con: 'Protocolo OPA de venta en camilla + sistema de packs que aumentan el ticket promedio'
  }, {
    situacion: 'Querés clientas que paguen más',
    sin: 'Seguís atrayendo el mismo perfil de siempre',
    con: 'Sistema de autoridad visual para Instagram que posiciona el precio premium antes de que escriban'
  }, {
    situacion: 'Tus clientas no vuelven solas',
    sin: 'Alta rotación sin fidelización real',
    con: 'Protocolo de los 3 primeros turnos + sistema de referidos que crece solo'
  }, {
    situacion: 'No sabés si tu negocio mejora',
    sin: 'Trabajás mucho sin datos concretos',
    con: 'Tracker mensual de 6 indicadores clave con metas claras para cada uno'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-177">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(236,72,153,0.03),transparent_70%)] pointer-events-none" data-id="element-178"></div>
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-179">
        <FadeIn data-id="element-180">
          <div className="text-center mb-16" data-id="element-181">
            <div className="inline-flex items-center justify-center bg-pink-500/10 px-4 py-2 rounded-full border border-pink-500/20 mb-6" data-id="element-182">
              <ShieldCheck className="w-5 h-5 text-pink-400 mr-2" data-id="element-183" />
              <span className="text-pink-400 font-bold tracking-[0.2em] text-[10px] md:text-xs uppercase font-sans" data-id="element-184">
                CONTENIDO EXCLUSIVO
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl text-white mb-6 leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-185">
              🛡️ ¿QUÉ AGREGA EXPANSIÓN PRO?
            </h2>
            <p className="text-gray-400 mt-4 max-w-2xl mx-auto text-base md:text-lg font-sans font-medium" data-id="element-186">
              Para profesionales que quieren pasar de apagar el incendio de hoy
              a tener un negocio que crezca con el tiempo.
            </p>
          </div>

          <div className="space-y-6 mb-16" data-id="element-187">
            {/* Desktop Header */}
            <div className="hidden md:grid grid-cols-3 gap-6 px-8 py-4 bg-navy-950/60 rounded-2xl border border-white/5 mb-2 font-sans" data-id="element-188">
              <div className="text-gray-400 font-bold text-xs uppercase tracking-widest" data-id="element-189">
                Situación
              </div>
              <div className="text-red-400/80 font-bold text-xs uppercase tracking-widest" data-id="element-190">
                ❌ Sin Expansión Pro
              </div>
              <div className="text-green-400 font-bold text-xs uppercase tracking-widest" data-id="element-191">
                ✅ Con Expansión Pro
              </div>
            </div>

            <div className="grid gap-4 md:gap-5" data-id="element-192">
              {comparisons.map((item, idx) => <div key={idx} className="bg-navy-950/40 rounded-2xl border border-white/5 p-5 md:p-6 overflow-hidden hover:border-white/10 transition-colors" data-id="element-193">
                  <div className="md:grid md:grid-cols-3 md:gap-6 items-start" data-id="element-194">
                    <div className="mb-5 md:mb-0" data-id="element-195">
                      <span className="text-[9px] uppercase tracking-[0.2em] text-gray-400 font-bold md:hidden block mb-2 font-sans" data-id="element-196">
                        Situación
                      </span>
                      <p className="text-white font-bold text-sm md:text-base leading-snug font-sans" data-id="element-197">
                        {item.situacion}
                      </p>
                    </div>

                    <div className="flex flex-col gap-4 md:contents" data-id="element-198">
                      <div className="md:pr-4" data-id="element-199">
                        <span className="text-[9px] uppercase tracking-[0.2em] text-red-400/80 font-bold md:hidden flex items-center gap-1.5 mb-2 font-sans" data-id="element-200">
                          ❌ Sin Expansión Pro
                        </span>
                        <p className="text-gray-300 text-xs md:text-sm leading-relaxed font-sans" data-id="element-201">
                          {item.sin}
                        </p>
                      </div>

                      <div className="bg-green-500/5 md:bg-transparent p-4 md:p-0 rounded-xl border border-green-500/10 md:border-none relative" data-id="element-202">
                        <span className="text-[9px] uppercase tracking-[0.2em] text-green-400 font-bold md:hidden flex items-center gap-1.5 mb-2 font-sans" data-id="element-203">
                          ✅ Con Expansión Pro
                        </span>
                        <p className="text-green-400 font-bold text-sm md:text-base leading-snug font-sans" data-id="element-204">
                          {item.con}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="bg-gradient-to-b from-navy-900 to-navy-950 border border-white/5 rounded-3xl p-6 md:p-12 relative overflow-hidden" data-id="element-205">
            <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-pink-500/30 to-transparent" data-id="element-206" />
            <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-pink-500/5 blur-3xl rounded-full" data-id="element-207"></div>

            <h3 className="text-xl md:text-3xl text-center text-white mb-8 md:mb-10 font-[900] font-[Montserrat,_sans-serif]" data-id="element-208">
              ✅ EXPANSIÓN PRO INCLUYE:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-209">
              {includes.map((item, index) => <div key={index} className="flex items-start space-x-4 bg-navy-950/50 border border-white/5 p-5 rounded-xl hover:bg-navy-900/50 transition-colors" data-id="element-210">
                  <CheckCircle2 className="w-5 h-5 text-pink-400 flex-shrink-0 mt-0.5 opacity-90" data-id="element-211" />
                  <span className="text-gray-100 font-medium text-sm md:text-base leading-relaxed font-sans" data-id="element-212">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};